import { toast } from 'react-toastify'
import { ConfiguredMiddleware } from 'wretch/types'

import { auth$ } from '~in-app/legend-state'
import { router } from '~in-app/router'

type AutoSignOut = () => ConfiguredMiddleware

export const autoSignOut: AutoSignOut = () => {
  return next => async (url, opts) => {
    try {
      const response = await next(url, opts)

      // Check if response is JSON before trying to read it
      const contentType = response.headers.get('content-type') || ''
      if (contentType.includes('application/json')) {
        const cloned = response.clone()
        const data = await cloned.json()
        if (data?.errorCode === '401' && data?.errorMessage === 'JWT-Invalid') {
          auth$.removeJWTToken()
          toast.error('Session Expired', { hideProgressBar: false, autoClose: 1500 })
          router.navigate({ to: '/sign-in' })
        }
      }

      return response
    }
    catch (err: any) {
      const response = err?.response

      if (response?.status === 401) {
        auth$.removeJWTToken()
        router.navigate({ to: '/sign-in' })
      }
      throw err
    }
  }
}
